export const selectUserProfile = (state) => state.user.profile;
export const selectEmailPreferences = (state) => state.user.emailPreferences;
export const selectUserIsLoading = (state) => state.user.isLoading;
